import type { CreateCorrectionPayload, UpdateCorrectionPayload } from '@kimuno/api-sdk';

import api from '../clients/api';
import { handleUnauthorized } from '../utils/apiWrapper';
import { notifyBugsnagNetwork } from '../utils/bugsnagClient';

const service = {
	uploadMaterial,
	deleteMaterial,
	getRemainingLimit,
	createCorrection,
	getCorrection,
	updateCorrection,
};

function uploadMaterial(formData: FormData, abortSignal?: AbortSignal) {
	notifyBugsnagNetwork('Corrections', 'uploadMaterial');
	return handleUnauthorized(() => api.corrections.uploadMaterial(formData, abortSignal));
}

function deleteMaterial(hashName: string) {
	notifyBugsnagNetwork('Corrections', 'deleteMaterial', { hashName });
	return handleUnauthorized(() => api.corrections.deleteMaterial(hashName));
}

function getRemainingLimit() {
	notifyBugsnagNetwork('Corrections', 'getRemainingLimit');
	return handleUnauthorized(() => api.corrections.getRemainingLimit());
}

function createCorrection(payload: CreateCorrectionPayload) {
	notifyBugsnagNetwork('Corrections', 'createCorrection', { ...payload });
	return handleUnauthorized(() => api.corrections.createCorrection(payload));
}

function getCorrection(correctionId: string) {
	notifyBugsnagNetwork('Corrections', 'getCorrection', { correctionId });
	return handleUnauthorized(() => api.corrections.getCorrection(correctionId));
}

function updateCorrection(correctionId: string, payload: UpdateCorrectionPayload) {
	notifyBugsnagNetwork('Corrections', 'updateCorrection', { correctionId });
	return handleUnauthorized(() => api.corrections.updateCorrection(correctionId, payload));
}

export default service;
